import React, { useRef, useState, useEffect } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import MemberService from "../../services/MemberService";
import axios from "axios";
import "./Menu.css";

const MenuLink = ({ label, to, onClick, activeOnlyWhenExact }) => {
    let match = useRouteMatch({
        path: to,
        exact: activeOnlyWhenExact
    });
  
    return (
        <Link underline="hover" className={match ? "active" : ""} to={to} onClick={onClick}>{label}</Link>
    );
}

function Menu({ className, options, onItemClicked }) {
    const classes = "menu " + className;
    const time = useRef(new Date());
    const [logoUrl, setLogoUrl] = useState('../portal-logo-with-background-fallback.png');

    useEffect(() => {
        const source = axios.CancelToken.source();
        
        MemberService.getPortalLogoWithBackground(source.token)
            .then(data => {
                if (data) {
                    // Check if data is HTML (img tag)
                    if (typeof data === 'string' && data.includes('<img') && data.includes('src=')) {
                        const srcMatch = data.match(/src=["']([^"']*)["']/i);
                        if (srcMatch && srcMatch[1]) {
                            setLogoUrl(srcMatch[1]);
                        }
                    } else if (typeof data === 'string') {
                        // If it's just a URL
                        setLogoUrl(data);
                    }
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.error('Error fetching portal logo with background:', error);
                }
            });
            
        return () => {
            source.cancel();
        };
    }, []);

    return (
        <nav className={classes}>
            <img className="logo" alt="[logo]" src={logoUrl}/>
            {/* <h5>Hello, {isSignedIn ? user.nickname : null}!</h5> */}
            <h5>
                Good&nbsp;
                {
                    time.current.getHours() < 12 ? (
                        "morning"
                    ) : time.current.getHours() < 18 ? (
                        "afternoon"
                    ) : (
                        "evening"
                    )
                }
                !
            </h5>
            <hr/>
            {options.map(({name, path, exact, items}) => {
                return items ? (
                    <React.Fragment key={name}>
                        <h4>{name}</h4>
                        <ul>
                            {items.map(link => 
                                <li key={link.name}>
                                    <MenuLink label={link.name} to={link.path} activeOnlyWhenExact={link.exact} onClick={onItemClicked} />
                                </li>
                            )}
                        </ul>
                    </React.Fragment>
                ) : (
                    <MenuLink key={name} label={name} to={path} activeOnlyWhenExact={exact} onClick={onItemClicked} />
                )
            })}
        </nav>
    )
}

export default Menu;